import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "editor"]

  edit(event) {
    event.preventDefault()
    this.summaryTarget.hidden = true
    this.editorTarget.hidden = false
    this.editorTarget.querySelector("input:not([type='hidden']), button")?.focus()
  }

  cancel(event) {
    event.preventDefault()
    this.editorTarget.hidden = true
    this.summaryTarget.hidden = false
  }
}
